import { Router, Sensors } from "@mui/icons-material";
import StatusChip from "../components/statusChip/statusChip.component";
import ActionButton from "../components/tableActions/tableActions.component";
import { actionsButtonsContainerSx } from "../styles/commonStyles";
import { SENSOR_STATUS_COLORS } from "../utils/statusConstants";
import { getSensorStatusLabel } from "../utils/sensorStatusUtils";

const MAPS_LINK = "https://maps.google.com";

const generateMapsLink = (positionArray) => {
  if (!positionArray || positionArray.length !== 2) return "#";
  const [lat, lng] = positionArray;
  return `${MAPS_LINK}?q=${lat},${lng}`;
};

export const toolsTableColumns = (sensorActions) => [
  { field: "id", headerName: "ID" },
  {
    field: "instrument_type",
    headerName: "Tipologia",
    flex: 0.12,
    minWidth: 100,
    renderCell: (params) => (
      <div
        style={{
          display: "flex",
          gap: "8px",
          height: "100%",
          alignItems: "center",
        }}
      >
        {params.value === "Sensor" ? (
          <Sensors sx={{ fontSize: 18 }} />
        ) : (
          <Router sx={{ fontSize: 18 }} />
        )}
        {params.value === "Sensor" ? "Sensore" : "Gateway"}
      </div>
    ),
  },
  {
    field: "nickname",
    headerName: "Nome",
    flex: 0.12,
    minWidth: 100,
  },
  {
    field: "devEUI",
    headerName: "EUI",
    flex: 0.12,
    minWidth: 100,
  },
  {
    field: "assigned_field",
    headerName: "Terreno",
    flex: 0.12,
    minWidth: 100,
    renderCell: (params) => {
      const fieldValue = params.value;
      const displayValue = !fieldValue
        ? "Non assegnato"
        : typeof fieldValue === "object" && fieldValue !== null
        ? fieldValue.name || JSON.stringify(fieldValue)
        : fieldValue;
      return (
        <span
          style={{
            color: fieldValue ? "inherit" : "#666",
            fontStyle: fieldValue ? "normal" : "italic",
          }}
        >
          {displayValue}
        </span>
      );
    },
  },
  {
    field: "gps_position",
    headerName: "Posizione",
    flex: 0.12,
    minWidth: 100,
    renderCell: (params) => (
      <a
        href={generateMapsLink(params.value)}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          color: "black",
          textDecoration: "underline",
          cursor: "pointer",
        }}
        onMouseOver={(e) => (e.target.style.textDecoration = "underline")}
        onMouseOut={(e) => (e.target.style.textDecoration = "none")}
      >
        Link GPS
      </a>
    ),
  },
  {
    field: "state",
    headerName: "Stato",
    flex: 0.12,
    minWidth: 100,
    renderCell: (params) => (
      <div
        style={{
          display: "flex",
          gap: "8px",
          flexWrap: "wrap",
          height: "100%",
          alignItems: "center",
        }}
      >
        <StatusChip
          status={getSensorStatusLabel(params.value)}
          colors={SENSOR_STATUS_COLORS}
        />
      </div>
    ),
  },
  {
    field: "actions",
    headerName: "Azioni",
    flex: 0.06,
    minWidth: 150,
    renderCell: (params) => (
      <div style={actionsButtonsContainerSx}>
        {sensorActions?.map((item, index) => {
          return (
            <ActionButton
              key={index}
              icon={item.icon}
              tooltip={item.tooltip}
              onClick={() => item.onClick(params.row.id)}
            />
          );
        })}
      </div>
    ),
  },
];
